export default __webpack_public_path__ + "static/heyo-6f1f7802cc4e6b4af28501a132b00c8d.webp";